module.exports = __webpack_public_path__ + "stylesheets/landing-template_ab01a189d0664319af8387008cd14213.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/landing-template.less
// module id = dy9G
// module chunks = 118